import { getAppConfig, $http } from 'larasnap';
import { Message } from 'larasnap/support';

const email = getAppConfig('support_email');
const link = `<a href="mailto:${email}">${email}</a>`;

export const showHelpMenu = () => {
    Message.info({
        icon: '',
        title: 'Need Help?',
        message: `
            If you have a question or would like to report a problem then you may
            send an email to ${link} or use the contact form below.
        `,
        input: 'textarea',
        inputPlaceholder: 'Type your message here...',
        confirmButtonText: 'Send Message',
        showCancelButton: true,
        cancelButtonText: 'Close',
        allowOutsideClick: false,
        showCloseButton: true,
        inputValidator: value =>
            value ? null : 'Your message cannot be blank',
    }).then(({ value, isConfirmed }) => {
        if (isConfirmed) {
            sendMessage(value);
        }
    });
};

const sendMessage = message => {
    $http
        .post('/support/send-message', { message })
        .then(() =>
            Message.success(
                'Your message has been sent. You will receive a response via email.',
            ),
        )
        .catch(() =>
            Message.error({
                title: 'Oops, an error occurred',
                message: `Please send your message to ${link}`,
                input: 'textarea',
                inputValue: message,
            }),
        );
};
